<header class="bg-main-blue-light h-screen w-full">
  <div class="relative h-full w-full">
    <!-- navbar layer -->
    <app-navbar></app-navbar>
    <!-- text layer -->
    <div class="absolute bottom-0 left-0 w-full h-full flex items-center justify-center z-10">
      <div class="flex flex-col items-center justify-center">
        <h1
          i18n="hero-section|Main headline@@hero.headline"
          class="text-3xl md:text-5xl font-bold text-white tracking-wide animate-fade-in-up text-center text-shadow-[0px_0px_10px_rgba(0,0,0,0.5)]"
        >
          Join games & Open runs
        </h1>
        <p
          i18n="hero-section|Subheadline@@hero.subheadline"
          class="text-white md:text-2xl text-xl tracking-wide mt-2 animate-fade-in-up-delay-1 text-center text-shadow-[0px_0px_10px_rgba(0,0,0,0.5)]"
        >
          Smart Booking for Sports <br />
          All on LINE
        </p>
        <a
          i18n="hero-section|Sign up button@@hero.signupButton"
          class="bg-transparent border text-sm border-white text-white px-5 py-2.5 rounded-full cursor-pointer mt-10 flex items-center justify-center hover:bg-main-yellow hover:text-white hover:border-0 transition-all duration-150 active:scale-95 animate-fade-in-up-delay-2"
          href="https://lin.ee/qe4HGmS"
          target="_blank"
        >
          SIGN UP for free
        </a>
      </div>
    </div>
    <!-- background layer -->
    <div class="absolute bottom-0 left-0 w-full h-full z-0 overflow-hidden">
      <div class="relative w-full h-full">
        <img
          src="hero_image/basketball.png"
          alt="Hero Section Basketball"
          class="absolute top-16 left-1/5 object-cover animate-move-in-down max-md:top-20 max-md:left-[-20px] w-32 h-32 md:w-36 md:h-36 lg:w-48 lg:h-48 2xl:w-60 2xl:h-60"
        />
        <img
          src="hero_image/football.png"
          alt="Hero Section Football"
          class="absolute bottom-1/3 left-4 object-cover animate-move-in-right w-24 h-24 md:w-36 md:h-36 lg:w-48 lg:h-48 2xl:w-60 2xl:h-60"
        />
        <img
          src="hero_image/mobile_left.png"
          alt="Hero Section mobile"
          class="absolute left-0 animate-move-in-up-right w-36 bottom-[-80px] md:w-56 md:bottom-[-180px] lg:w-72 lg:bottom-[-250px] 2xl:w-96 2xl:bottom-[-320px]"
        />
        <img
          src="hero_image/mobile_right.png"
          alt="Hero Section mobile"
          class="absolute bottom-14 right-[-50px] md:bottom-20 md:right-5 animate-move-in-left-rotate-neg13 w-36 sm:w-44 lg:w-72 2xl:w-96"
        />
        <img
          src="hero_image/tennis.png"
          alt="Hero Section Tennis"
          class="absolute bottom-0 animate-move-in-left w-20 h-20 right-16 md:w-32 md:h-32 md:right-32 lg:w-40 lg:h-40 lg:right-44 2xl:w-52 2xl:h-52 2xl:right-56"
        />
      </div>
    </div>
    <!-- dropdown layer -->
    <div class="absolute bottom-0 right-0 w-full flex items-center justify-center pb-10 z-20">
      <button
        (click)="onScrollToMainContent()"
        class="cursor-pointer hover:scale-110 transition-all duration-300 active:scale-95"
      >
        <img src="dropdown.svg" alt="Dropdown" class="md:w-10 md:h-10 w-8 h-8 animate-bounce" />
      </button>
    </div>
  </div>
</header>
